import { deliveredDesign, deliveredPalette, deliveredStyles } from "./delivered-designs.js";
export { deliveredDesign } from "./delivered-designs.js";
// Keep stored identifiers compatible with existing accounts and older installations.
// Legacy identifiers remain accepted by older app installations; the current UI uses one shared layout.
export const LAYOUT_KEYS = ["modern2", "accessible"];
const STORED_LAYOUT_KEYS = ["simple", "modern", "technical", ...LAYOUT_KEYS];
export const validLayout = value => STORED_LAYOUT_KEYS.includes(value);
export const normalizeLayout = value => value === "accessible" || value === "simple" ? "accessible" : "modern2";
export const APP_NAVIGATION = [
  { key: "overview", symbol: "⌂" }, { key: "map", symbol: "⌖" }, { key: "care", symbol: "♥" },
  { key: "events", symbol: "!" }, { key: "activity", symbol: "◌" }, { key: "device", symbol: "▣" },
];
export function layoutPalette(base, layout, dark) {
  return deliveredPalette(base, normalizeLayout(layout), dark);
}
export function adaptLayoutStyles(sheet, layout, mono = "monospace") {
  return deliveredStyles(sheet, normalizeLayout(layout));
}
